function downloadBlob (blob, filename) {
  const url = URL.createObjectURL(blob)
  const anchorElement = document.createElement('a')

  anchorElement.href = url
  anchorElement.download = filename || 'download'

  // Click handler that releases the object URL after the element has been clicked
  // This is required for one-off downloads of the blob content
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url)
      removeEventListener('click', clickHandler)
    }, 150)
  }

  anchorElement.addEventListener('click', clickHandler, false)

  anchorElement.click()
  return anchorElement
}

export default downloadBlob
